import React, { useState, useEffect } from 'react';

const COLORS = {
  primary: "#0760ad",
  secondary: "#118a94",
  primaryLight: "#098a48",
  white: "#FFFFFF"
};

const DEFAULT_SERVICES = {
  heading: "Additional Services",
  services: [
    {
      title: "Preventive Health Screenings",
      description: "Comprehensive check-ups to detect potential health issues before they become serious",
      color: COLORS.primary,
      icon: "health"
    }
  ]
};

const ServiceCards = ({ isAdmin = false, onEdit }) => {
  const [servicesData, setServicesData] = useState(DEFAULT_SERVICES);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchServicesData = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/services/service-cards/`);
        if (response.ok) {
          const data = await response.json();
          setServicesData(data);
        } else {
          console.error('Failed to fetch service cards data');
        }
      } catch (error) {
        console.error('Error fetching service cards data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchServicesData();
  }, []);

  if (isLoading) {
    return (
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-center">
            <span className="loading loading-spinner loading-lg"></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12" style={{ color: COLORS.primary }}>
          {servicesData.heading || DEFAULT_SERVICES.heading}
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {servicesData.services?.map((service, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              style={{ borderTop: `4px solid ${service.color || COLORS.primary}` }}
            >
              <h3 className="text-xl font-semibold mb-4" style={{ color: service.color || COLORS.primary }}>
                {service.title || "Service Title"}
              </h3>
              <p className="text-gray-700">
                {service.description || "Service description will appear here."}
              </p>
            </div>
          ))}
        </div>

        {isAdmin && (
          <div className="text-center mt-12">
            <button 
              onClick={onEdit}
              className="btn btn-primary"
            >
              Edit Service Cards
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceCards;